import { ProjectRegisterGroupBy } from "./projectRegisterTableUtils";
import {
  getProjectRegisterGroupLabel,
  ProjectRegisterGroupableFields,
  toProjectRegisterNumber,
} from "./projectRegisterGroupingUtils";

type TimelineFinancialMetricRow = ProjectRegisterGroupableFields & {
  measureName?: string | null;
  year?: number | null;
  emissionReduction?: number | string | null;
};

const getMeasureName = (value: string | null | undefined) => {
  const normalizedValue = value?.trim();

  return normalizedValue && normalizedValue.length > 0
    ? normalizedValue
    : "Unspecified";
};

export const getTimelineFinancialMetricByGroup = (
  items: TimelineFinancialMetricRow[] | null | undefined,
  groupBy: ProjectRegisterGroupBy
) => {
  const sourceItems = items ?? [];

  if (groupBy === "Name") {
    return sourceItems.map((item) => ({
      ...item,
      measureName: getMeasureName(item.measureName),
    }));
  }

  const groupedItems = sourceItems.reduce<Record<string, TimelineFinancialMetricRow>>(
    (accumulator, item) => {
      const groupLabel = getProjectRegisterGroupLabel(
        {
          measureType: item.measureType,
          measureCategory: item.measureCategory,
          name: item.measureName,
        },
        groupBy
      );
      const year = item.year ?? 0;
      const key = `${groupLabel}::${year}`;
      const existingGroup = accumulator[key];

      if (!existingGroup) {
        accumulator[key] = {
          ...item,
          measureName: groupLabel,
          year,
          emissionReduction: toProjectRegisterNumber(item.emissionReduction),
        };
        return accumulator;
      }

      existingGroup.emissionReduction =
        toProjectRegisterNumber(existingGroup.emissionReduction) +
        toProjectRegisterNumber(item.emissionReduction);

      return accumulator;
    },
    {}
  );

  return Object.values(groupedItems).sort(
    (left, right) =>
      toProjectRegisterNumber(left.year) - toProjectRegisterNumber(right.year) ||
      getProjectRegisterGroupLabel(
        {
          measureType: left.measureType,
          measureCategory: left.measureCategory,
          name: left.measureName,
        },
        "Name"
      ).localeCompare(
        getProjectRegisterGroupLabel(
          {
            measureType: right.measureType,
            measureCategory: right.measureCategory,
            name: right.measureName,
          },
          "Name"
        )
      )
  );
};